import { useState, type FormEvent } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Button, Input } from '../components/ui';
import { ErrorState } from '../components/states';
import { useSession } from '../app/session';

type LocationState = { from?: string } | null;

export function Login() {
  const { signIn } = useSession();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as LocationState)?.from ?? '/';

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError('');
    try {
      await signIn(email.trim(), password);
      navigate(from, { replace: true });
    } catch {
      setError('Email or password is incorrect.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="workspace-main">
      <section className="panel auth-panel">
        <header className="panel-heading">
          <span className="index-label">AUTH / SIGN IN</span>
        </header>
        <div className="panel-body">
          <h1>Sign in</h1>
          {error && <ErrorState title="Sign in failed" detail={error} />}
          <form onSubmit={onSubmit} className="auth-form">
            <label className="index-label" htmlFor="email">
              EMAIL
            </label>
            <Input
              id="email"
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
            <label className="index-label" htmlFor="password">
              PASSWORD
            </label>
            <Input
              id="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
            <div className="auth-actions">
              <Button type="submit" disabled={busy}>
                {busy ? 'Signing in…' : 'Sign in'}
              </Button>
              <Link className="auth-link" to="/forgot-password">
                Forgot password?
              </Link>
            </div>
          </form>
        </div>
      </section>
    </main>
  );
}
